import { render, staticRenderFns } from "./membership-table-input.vue?vue&type=template&id=47af8b65&scoped=true&"
import script from "./membership-table-input.vue?vue&type=script&lang=ts&"
export * from "./membership-table-input.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47af8b65",
  null
  
)

export default component.exports